document.addEventListener("DOMContentLoaded", function() {

const searchInput = document.getElementById("downloadSearch");

if(!searchInput) return;

const items = document.querySelectorAll(".download-list li");

function normalize(text){
return text.toLowerCase().replace(/-/g,"").replace(/\s/g,"");
}

searchInput.addEventListener("keyup", function(){

const filter = normalize(searchInput.value);

items.forEach(function(item){

const text = normalize(item.textContent);

item.classList.remove("download-match");

if(filter === ""){
item.style.display = "";
return;
}

if(text.includes(filter)){

item.style.display = "";
item.classList.add("download-match");

}else{

item.style.display = "none";

}

});

});

});